import { createFileRoute } from "@tanstack/react-router"

import { CoachDashboard } from "@/pages/CoachDashboard"

export const Route = createFileRoute("/_layout/coach")({
  component: CoachDashboard,
})
